<template>
  <div>
    <b-modal v-model="showModal"
      title="Detalle del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <div><span><b>Fecha:</b> {{ record.date }}</span></div>
      <div><span><b>Log:</b> {{ record.lognamelbl }}</span></div>
      <div><span><b>Descripción:</b> {{ record.description }}</span></div>
      <div><span><b>Usuario:</b> {{ record.causername }}</span></div>
      <div><span><b>Registro:</b> {{ record.subjectname }}</span></div>

      <div v-if="hasChanges">
        <hr>
        <div><span><b>Cambios:</b></span></div>
        <div class="table-responsive">
          <table class="table table-sm table-striped table-bordered mt-1">
            <thead>
              <tr>
                <th>Campo</th>
                <th>Valor anterior</th>
                <th>Valor nuevo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="field in changedFields" :key="field">
                <td>{{ field }}</td>
                <td>{{ formatValue(oldValues[field]) }}</td>
                <td>{{ formatValue(newValues[field]) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-else-if="record.properties && Object.keys(record.properties).length">
        <hr>
        <div><span><b>Propiedades:</b></span></div>
        <pre class="mt-1" style="white-space: pre-wrap; word-break: break-word;">{{ JSON.stringify(record.properties, null, 2) }}</pre>
      </div>

      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['record', 'showModal'],
  computed: {
    // Los logs de LOGIN/LOGOUT traen otra forma de 'properties', por eso se
    // comprueba explícitamente que exista 'attributes'.
    newValues() {
      return (this.record && this.record.properties && this.record.properties.attributes) || {};
    },
    oldValues() {
      return (this.record && this.record.properties && this.record.properties.old) || {};
    },
    changedFields() {
      return Object.keys(this.newValues);
    },
    hasChanges() {
      return this.changedFields.length > 0;
    },
  },
  methods:{
    formatValue(value) {
      if (value === null || value === undefined) {
        return '—';
      }
      if (typeof value === 'object') {
        return JSON.stringify(value);
      }
      if (typeof value === 'boolean') {
        return value ? 'Sí' : 'No';
      }
      return value;
    },
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
    },
  }
}

</script>
